var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLocationWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.9 7.88203C6.91482 7.88203 7.7375 7.05935 7.7375 6.04453C7.7375 5.02971 6.91482 4.20703 5.9 4.20703C4.88518 4.20703 4.0625 5.02971 4.0625 6.04453C4.0625 7.05935 4.88518 7.88203 5.9 7.88203Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9 1.14453C4.60044 1.14453 3.35411 1.66078 2.43518 2.57971C1.51625 3.49864 1 4.74497 1 6.04453C1 7.20338 1.24622 7.96166 1.91875 8.80078L5.9 13.3945L9.88125 8.80078C10.5538 7.96166 10.8 7.20338 10.8 6.04453C10.8 4.74497 10.2838 3.49864 9.36482 2.57971C8.4459 1.66078 7.19956 1.14453 5.9 1.14453V1.14453Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocationWhite);
export default __webpack_public_path__ + "static/media/icon_location_white.c60ad50e7ffa2a90bc3155c5574bcaba.svg";
export { ForwardRef as ReactComponent };